module.exports = __webpack_public_path__ + "static/media/zimaBoard.a09e79aa.png";